import styled from '@emotion/styled';

import EnumSelect from 'components/field/EnumSelect';
import Card from 'components/global/Card';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Wrapper = styled(Card)`
	padding: 0 !important;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 2.4rem;

	@media (${Breakpoints.mobile}) {
		flex-direction: column;
		align-items: flex-start;
		gap: 1.6rem;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5.6rem;
`;

export const PriceSwitch = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;

export const PackageList = styled.div`
	.swiper {
		width: 100%;
		height: 100%;
		margin-left: auto;
		margin-right: auto;
		position: relative;
	}

	.swiper-wrapper {
		padding-bottom: 0.5rem;
		gap: 1.8rem;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		@media (${Breakpoints.mobile}) {
			display: flex;
			padding-bottom: 6rem;
			gap: 0;
		}
	}
	.swiper-slide {
		height: auto;
		box-sizing: border-box;
		width: 100% !important;
	}
`;

export const PackageItemImage = styled.div`
	flex-shrink: 0;
	& > img {
		border-radius: 50%;
	}

	.icon {
		border-radius: 50% !important;
	}
`;

export const PackageItem = styled(Card)`
	height: 100%;
	padding: 0 !important;
	display: flex;
	flex-direction: column;
	overflow: visible;
`;

export const PackageItemContent = styled.div`
	padding: 2.65rem 1.8rem;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 1.6rem;
`;

export const MostPopular = styled.div`
	background: var(--black);
	color: var(--white);
	padding: 0.5rem 2rem;
	border-radius: 0 0 2rem 0;
	width: 13rem;
	visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
	transition: visibility 0.3s ease-in-out;
	body[dir='rtl'] & {
		border-radius: 0 0 0 2rem;
		padding: 0.5rem 2rem;
	}
`;

export const PlanName = styled.div`
	display: flex;
	align-items: center;
	gap: 1.6rem;
`;

export const PriceContainer = styled.div`
	display: grid;
	grid-template-rows: 1fr 1fr;
`;

export const Price = styled.div`
	display: flex;
	align-items: center;
	gap: 0.4rem;
`;

export const FeaturesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	margin-top: 1.6rem;

	h3 {
		margin-bottom: 0.8rem;
		color: var(--gray-900);
		font-size: 1.4rem;
		font-weight: 500;
	}
`;

export const FeatureItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin-top: 1.6rem;
`;

export const FeatureItemIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const FeatureItemText = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
	color: var(--gray-700);
	font-size: 1.3rem;

	.icon {
		color: var(--green);
		font-size: 1.2rem;
		flex-shrink: 0;
		align-self: flex-start;
		margin-top: 0.2rem;
	}

	p {
		word-break: break-word;
		line-height: 1.4;
	}
`;

export const SearchContainer = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
	align-items: center;
	gap: 1.6rem;

	@media (${Breakpoints.mobile}) {
		grid-template-columns: 1fr;
	}
`;

export const FiltersContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1.6rem;

	& > div {
		flex: 1;
	}

	.enumSelect {
		width: 21rem;
		@media (${Breakpoints.mobile}) {
			width: 19.5rem;
		}
	}
`;

export const Enum = styled(EnumSelect)`
	flex: 1;
`;

export const PlansContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
`;

export const Plan = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const PlanHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const ModulesContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(39rem, 1fr));
	gap: 2.6rem;
`;

export const ModuleCard = styled(Card)`
	flex: 1;
	box-sizing: border-box;
`;

export const ModuleItem = styled.div`
	display: flex;
	gap: 1.6rem;
	height: 100%;
`;

export const ModuleImage = styled(Image)`
	flex-shrink: 0;
`;

export const ModuleContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 1.6rem;
	flex: 1;
`;

export const ModuleInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`;

export const ModuleHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1.8rem;
	width: 100%;
	margin-bottom: 0.8rem;
`;

export const ModuleTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
`;

export const CheckedIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	background-color: var(--green);
`;

export const Actions = styled.div`
	margin-top: auto;
	width: 100%;
`;

export const SuccessModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 3rem;
	padding: 0 5rem;
`;

export const SuccessModalTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	text-align: center;
`;
